export const routes = [
  {
    path: 'studio',
    name: 'talkvia_studio',
    meta: { permissions: ['administrator', 'agent'] },
    component: () => import('./Index.vue'),
  },
];
